module.exports = __webpack_public_path__ + "static/media/api-about-sdk.d91bb044.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/developerApi/developerSdk/Overview/images/api-about-sdk.png
// module id = 427
// module chunks = 0